import React, { useState, useEffect, useRef } from 'react';
import WheelMascot from './WheelMascot';

/**
 * Large wheel mascot for the winner result popup.
 *
 * Mount sequence:
 * 1. Spins for 0.8 s
 * 2. Settles (decelerate + bounce) via the mascot-settle animation
 * 3. After settling, the pointer glows with a violet pulse
 */
interface WinnerCelebrationProps {
  className?: string;
}

const WinnerCelebration: React.FC<WinnerCelebrationProps> = ({ className = '' }) => {
  const [spinning, setSpinning] = useState(true);
  const [glowing, setGlowing]   = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;

    // Spin for 0.8s, then stop (which triggers the settle animation)
    const spinTimer = setTimeout(() => {
      if (mounted.current) setSpinning(false);
    }, 800);

    // After settle (800ms settle animation), start the glow
    const glowTimer = setTimeout(() => {
      if (mounted.current) setGlowing(true);
    }, 1600); // 800ms spin + 800ms settle

    return () => {
      mounted.current = false;
      clearTimeout(spinTimer);
      clearTimeout(glowTimer);
    };
  }, []);

  return (
    <div className={`flex justify-center ${className}`}>
      <div className={glowing ? 'mascot-pointer-glow' : ''}>
        <WheelMascot size={120} spinning={spinning} />
      </div>
    </div>
  );
};

export default WinnerCelebration;
